import { AppDispatch } from 'src/app/store'
import { BalanceType } from 'src/core/models'
import * as api from './summaryAPI'
import * as reducers from './summarySlice'


const getBalance = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setBalanceLoading(true))
    const data: BalanceType[] = await api.getBalanceAPI()
    dispatch(reducers.setBalanceLoading(false))
    dispatch(reducers.setBalanceResponse(data))
  } catch (error) {
    dispatch(reducers.setBalanceLoading(false))
    dispatch(reducers.setBalanceError(error))
  }
}

const setFilter = (filter: number) => (dispatch: AppDispatch) => {
  dispatch(reducers.setFilter(filter))
}

const getUserSalesData = (filter: number = 365) => async (dispatch) => {
  try {
    dispatch(reducers.setSalesDataLoading(true))
    dispatch(reducers.setSalesDataPlot(false))
    const data = await api.salesData(filter)
    dispatch(reducers.setSalesDataLoading(false))
    dispatch(reducers.setSalesDataResponse(data))
    dispatch(reducers.setSalesDataPlot(true))
  } catch (error) {
    dispatch(reducers.setSalesDataLoading(false))
    dispatch(reducers.setSalesDataError(error))
  }
}

const getUserOrdersData = (filter: number= 365) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setOrdersDataLoading(true))
    dispatch(reducers.setOrdersDataPlot(false))
    const data = await api.ordersData(filter)
    dispatch(reducers.setOrdersDataLoading(false))
    dispatch(reducers.setOrdersDataResponse(data))
    dispatch(reducers.setOrdersDataPlot(true))
  } catch (error) {
    dispatch(reducers.setOrdersDataLoading(false))
    dispatch(reducers.setOrdersDataError(error))
  }
}

const createBankTransferDeposit = (payload) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setDepositSuccess(false))
    dispatch(reducers.setDepositLoading(true))
    const data = await api.createDepositAPI(payload)
    dispatch(reducers.setDepositLoading(false))
    dispatch(reducers.setDepositResponse(data))
    dispatch(reducers.setDepositSuccess(true))
  } catch (error){
    dispatch(reducers.setDepositLoading(false))
    dispatch(reducers.setDepositError(error))
  }
}

const createPayPalDeposit = (payload) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setDepositLoading(true))
    const { id } = await api.createDepositAPI(payload)
    const { url } = await api.getPaymentUrl(id)
    dispatch(reducers.setDepositLoading(false))
    dispatch(reducers.setDepositPayPalUrl(url))
  }catch (error){
    dispatch(reducers.setDepositLoading(false))
    dispatch(reducers.setDepositError(error))
  }
}

const createCreditCardDeposit = (payload) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setDepositLoading(true))
    dispatch(reducers.setDepositSubmit(true))
    await api.createDeposit(payload)
    const data: BalanceType[] = await api.getBalanceAPI()
    dispatch(reducers.setBalanceResponse(data))
    dispatch(reducers.setDepositSubmit(false))
    dispatch(reducers.setDepositLoading(false))
  }catch (error){
    dispatch(reducers.setDepositLoading(false))
    dispatch(reducers.setDepositError(error))
  }
}

const createWithdrawPayPal = (payload: FormData) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setWithdrawPayPalLoading(true))
    await api.createWithdrawWithPayPal(payload)
    dispatch(reducers.setWithdrawPayPalSuccess(true))
    dispatch(reducers.setWithdrawPayPalLoading(false))
  }catch (error){
    dispatch(reducers.setWithdrawPayPalLoading(false))
    dispatch(reducers.setWithdrawPayPalError(error.response.data.message_error))
  }
}

export {
  getBalance,
  setFilter,
  getUserSalesData,
  getUserOrdersData,
  createPayPalDeposit,
  createWithdrawPayPal,
  createCreditCardDeposit,
  createBankTransferDeposit
}
